var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-menu'),_vm._v(" "),_c('app-content'),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('app-snackbar'),_vm._v(" "),_c('app-informacao')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }